import { formatStripeCode } from "@utils/format";
import { MoneyUnit, formatPrice } from "@utils/pricing";
import { AccountHeader, PaymentTable, StyledDisclaimer } from "../Account.styled";
import { PaymentStatusProps } from "./PaymentHistory.model";
import PortableText from "@components/portable-text";

const PaymentStatusList = ({ isDigital, digitalDisclaimer, charges }: PaymentStatusProps) => {
  return (
    <>
      <AccountHeader>
        <h3>Payment Status History</h3>
      </AccountHeader>
      {isDigital && digitalDisclaimer && (
        <StyledDisclaimer>
          <PortableText value={digitalDisclaimer} />
        </StyledDisclaimer>
      )}
      <article>
        <PaymentTable>
          <thead>
            <tr>
              <th>Amount</th>
              <th>Status</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {charges.map((charge) => (
              <tr key={charge.id}>
                <td>{formatPrice(charge.amount, MoneyUnit.CENT)}</td>
                <td>{formatStripeCode(charge.status)}</td>
                <td>{charge.failure_message}</td>
              </tr>
            ))}
          </tbody>
        </PaymentTable>
      </article>
    </>
  );
};

export default PaymentStatusList;
